<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showVehicleRequest") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #000">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-between">
        <div class="wrapper">
          <v-chip color="amber darken-2" text-color="white">
            {{ $t("PLACEHOLDERS.requestDate", { date: data.created_at }) }}
          </v-chip>
        </div>

        <v-chip color="grey" text-color="white">
          {{ data.status }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Office Main Data ==== -->
      <form>
        <div class="row">
          <h6 class="col-12 mb-3">{{ $t("PLACEHOLDERS.officeInfo") }}</h6>

          <!-- Start:: Office Name Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.officeName')"
            v-model.trim="data.provider.name"
            disabled
          />
          <!-- End:: Office Name Input -->

          <!-- Start:: Office Type Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.officeType')"
            v-model.trim="data.provider.exhibitor_type_trans"
            disabled
          />
          <!-- End:: Office Type Input -->

          <!-- Start:: Phone Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.provider.phone"
            disabled
          />
          <!-- End:: Phone Input -->

          <h6 class="col-12 mb-3 mt-4">{{ $t("PLACEHOLDERS.vehicleInfo") }}</h6>

          <!-- Start:: Vehicle Type Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.vehicleType')"
            v-model.trim="data.vehicle_type"
            disabled
          />
          <!-- End:: Vehicle Type Input -->

          <!-- Start:: Vehicle Brand Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.brand')"
            v-model.trim="data.vehicle_model.vehicle_brand.name"
            disabled
          />
          <!-- End:: Vehicle Brand Input -->

          <!-- Start:: Vehicle Model Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.model')"
            v-model.trim="data.vehicle_model.name"
            disabled
          />
          <!-- End:: Vehicle Model Input -->

          <!-- Start:: Model Year Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.model_year')"
            v-model.trim="data.model_year"
            disabled
          />
          <!-- End:: Model Year Input -->

          <!-- Start:: License Plate Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.licensePlate')"
            v-model.trim="data.license_plate"
            disabled
          />
          <!-- End:: License Plate Input -->

          <!-- Start:: Country Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.country')"
            v-model.trim="data.country"
            disabled
          />
          <!-- End:: Country Input -->

          <!-- Start:: Fuel Type Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.fuelType')"
            v-model.trim="data.fuel_type"
            disabled
          />
          <!-- End:: Fuel Type Input -->

          <!-- Start:: Transmission Type Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.transmissionType')"
            v-model.trim="data.transmission_type"
            disabled
          />
          <!-- End:: Transmission Type Input -->

          <!-- Start:: Number of Doors Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.numberOfDoors')"
            v-model.trim="data.number_of_doors"
            disabled
          />
          <!-- End:: Number of Doors Input -->

          <!-- Start:: Number of Seats Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.numberOfSeats')"
            v-model.trim="data.number_of_seats"
            disabled
          />
          <!-- End:: Number of Seats Input -->

          <!-- Start:: Price Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.price')"
            v-model.trim="data.price"
            disabled
          />
          <!-- End:: Price Input -->

          <!-- Start:: Additional Features Input -->
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.additionalFeatures')"
            v-model.trim="data.additional_features"
            disabled
          />
          <!-- End:: Additional Features Input -->

          <!-- Start:: Condition Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.isGoodCondition')"
            v-model.trim="data.condition_status"
            disabled
          />
          <!-- End:: Condition Input -->

          <!-- Start:: Road Test Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.hasRoadTest')"
            v-model.trim="data.road_test_status"
            disabled
          />
          <!-- End:: Road Test Input -->

          <!-- Start:: Vehicle Images -->
          <div class="col-12" v-if="data.images && data.images.length">
            <h6 class="mb-3">{{ $t("PLACEHOLDERS.vehicleImages") }}</h6>
            <div class="row">
              <div
                v-for="(image, index) in data.images"
                :key="index"
                class="col-3 mb-3"
              >
                <img
                  :src="image.url || image"
                  :alt="`Vehicle image ${index + 1}`"
                  class="vehicle-image"
                  @click="showImageModal(image.url || image)"
                />
              </div>
            </div>
          </div>
          <!-- End:: Vehicle Images -->
        </div>
      </form>
      <!-- ==== End:: Office Main Data ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "SingleVehicleRequest",
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {
        provider: {
          name: null,
          exhibitor_type_trans: null,
          phone: null,
        },
        vehicle_type: null,
        vehicle_model: {
          name: null,
          vehicle_brand: {
            name: null,
          },
        },
        model_year: null,
        license_plate: null,
        country: null,
        fuel_type: null,
        transmission_type: null,
        number_of_doors: null,
        number_of_seats: null,
        price: null,
        additional_features: null,
        condition_status: null,
        road_test_status: null,
        images: [],
        status: null,
        created_at: null,
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `vehicles-requests/${this.$route.params.id}`,
        });
        const vehicleData = res.data.data.Vehicle;

        this.data = {
          provider: {
            name: vehicleData.provider?.name,
            exhibitor_type_trans: vehicleData.provider?.exhibitor_type_trans,
            phone: vehicleData.provider?.mobile,
          },
          vehicle_type:
            vehicleData.vehicle_model?.vehicle_brand?.vehicle_type?.name,
          vehicle_model: {
            name: vehicleData.vehicle_model?.name,
            vehicle_brand: {
              name: vehicleData.vehicle_model?.vehicle_brand?.name,
            },
          },
          model_year: vehicleData.model_year,
          license_plate: vehicleData.plate_number,
          country: vehicleData.registration_country?.name,
          fuel_type: vehicleData.fuel_type?.name,
          transmission_type: vehicleData.gear_type?.name,
          number_of_doors: vehicleData.number_doors,
          number_of_seats: vehicleData.number_seats,
          price: vehicleData.price + " " + vehicleData.currency,
          additional_features:
            vehicleData.features?.map((feature) => feature.name).join(", ") ||
            "لا توجد مميزات إضافية",
          condition_status: vehicleData.is_good_condition
            ? this.$t("PLACEHOLDERS.yes")
            : this.$t("PLACEHOLDERS.no"),
          road_test_status: vehicleData.has_road_test
            ? this.$t("PLACEHOLDERS.yes")
            : this.$t("PLACEHOLDERS.no"),
          images: vehicleData.vehicle_images || [],
          status: vehicleData.status_trans,
          created_at: vehicleData.created_at,
        };
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    // Status helpers
    getStatusColor(status) {
      switch (status) {
        case "pending_review":
          return "orange";
        case "published":
          return "green";
        case "rejected":
          return "red";
        default:
          return "grey";
      }
    },

    getStatusText(status) {
      switch (status) {
        case "pending_review":
          return this.$t("PLACEHOLDERS.pendingReview");
        case "published":
          return this.$t("PLACEHOLDERS.published");
        case "rejected":
          return this.$t("PLACEHOLDERS.rejected");
        default:
          return this.$t("PLACEHOLDERS.unknown");
      }
    },

    showImageModal(imageUrl) {
      // Implement image modal logic if needed
      window.open(imageUrl, "_blank");
    },
    // End:: Get Data To Show
  },

  created() {
    // Start:: Fire Methods
    this.getDataToShow();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.vehicle-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.vehicle-image:hover {
  transform: scale(1.05);
}

.badges_wrapper {
  margin-bottom: 20px;
}

.single_step_form_content_wrapper {
  padding: 20px;
}
</style>
